import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 501\" id=\"icon-play\">\n  <path d=\"M337.575656,192.257363 C343.474781,195.734985 343.474781,204.265004 337.575656,207.742626 L13.5606146,398.74043 C7.56597012,402.273781 0,397.953942 0,390.997798 L0,9.00210147 C0,2.04581322 7.56600609,-2.27390843 13.5606146,1.25977519 L337.575656,192.257363 Z\" transform=\"translate(86 48)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol